import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { Partner } = protos;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function insert(request: any): ApiAction {
  return {
    TockApi: {
      postProto: `/partner/internal?adminEmail=${request.adminEmail}`,
      type: ClowncarAppConstants.PARTNER_INSERT,
      request: Partner.fromObject(request),
      toast: 'Partner added to Tock',
    },
  };
}

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/partner/internal/all',
      type: ClowncarAppConstants.PARTNER_FETCH_ALL,
    },
  };
}
